module.exports = __webpack_public_path__ + "media/images/efectivo-0a07be4f82a6519a5358ccaddb7ebb50.svg";